export const CONTACT = {
  name: "Diogo Almeida",
  role_pt: "Diretor de Loja · Gestor de Crédito",
  role_en: "Branch Manager · Mortgage Advisor",
  company: "Decisão Ordenada, Lda",
  registry: "Intermediário de Crédito Vinculado · Banco de Portugal nº 0006056",
  phone: "+351965405031",
  phoneDisplay: "+351 965 405 031",
  email: "diogoalmeida@dsicredito.pt",
  address: "Proa Mar Building, Av. de Ceuta nº 3 Store B, 8125-507 Quarteira",
  gmaps: "https://maps.app.goo.gl/WJTWhJ6n239xTXvv5",
  reviewUrl: "https://search.google.com/local/writereview?placeid=ChIJX5kQNkm1Gg0RX813ouCcUjk",
  geo: { lat: 37.0688357, lng: -8.0993321 },
  calendar: "https://calendar.app.google/DALGM4T82cuxYB9a7",
  calendarEmbed:
    "https://calendar.google.com/calendar/appointments/schedules/AcZssZ1_tOa4ts8pgUryc4dPE54_rejHiKeGLJRj7GPklgLKbgMcKmQs6scGN2LjNDGmPbDTpZ812A2N?gv=true",
  facebook: "https://www.facebook.com/diogoalmeidaDS",
  facebookReviews: "https://www.facebook.com/diogoalmeidaDS/reviews",
  instagram: "https://www.instagram.com/diogoalmeidads",
  linkedin: "https://www.linkedin.com/in/diogoalmeidads",
  whatsapp: (msg) =>
    `https://wa.me/351965405031?text=${encodeURIComponent(
      msg || "Olá Diogo, gostaria de saber mais sobre crédito habitação."
    )}`,
};

// Banks + financeiras — official partners
// Logos hosted locally in /public/banks/ for performance & reliability.
// When `logo` is null, the component falls back to elegant text typography.
export const PARTNERS = [
  { name: "Banco BPI", logo: "/banks/bpi.png" },
  { name: "Santander", logo: "/banks/santander.svg" },
  { name: "Caixa Geral de Depósitos", logo: "/banks/cgd.jpg", scale: 1.25 },
  { name: "Novo Banco", logo: "/banks/novobanco.svg" },
  { name: "Banco CTT", logo: "/banks/bancoctt.png" },
  { name: "Bankinter", logo: "/banks/bankinter.svg" },
  { name: "ABANCA", logo: "/banks/abanca.svg" },
  { name: "UCI", logo: "/banks/uci.svg" },
  { name: "BNI Europa", logo: "/banks/bni-europa.png" },
  { name: "Crédito Agrícola", logo: "/banks/credito-agricola.png" },
  { name: "Cofidis", logo: "/banks/cofidis.png", scale: 1.55 },
  { name: "Cetelem", logo: "/banks/cetelem.png", scale: 1.45 },
];
